import { THEME_SCALE } from "../theme";

export const HEIGHT = 160 * THEME_SCALE;
export const MOBILE_HEIGHT = 60;
export const MOBILE_ZOOM125_HEIGHT = 50;
